import { css, cx } from '@emotion/css';
import PoweredByUxSignals from './common/PoweredByUxSignals';
import BookingConfirmed from './steps/BookingConfirmed';
import { Step } from './steps/Step';
import { useStudyContext } from './utils/StudyContext';

import ThankYouMessage from './steps/ThankYouMessage';
import type { CalendarStepT, StepT } from './steps/types';

type Props = {
    currentStep: number;
    answers: StepT[];
    answerStep: (step: StepT) => Promise<void>;
};

const Steps = ({ currentStep, answers, answerStep }: Props) => {
    const { study } = useStudyContext();

    if (currentStep < study.steps.length) {
        return (
            <>
                <Step
                    step={study.steps[currentStep] as StepT}
                    answerStep={answerStep}
                />
                <div className={cx(CenterStyle, BottomStyle, FooterStyle)}>
                    <PoweredByUxSignals />
                </div>
            </>
        );
    }

    const calendarStepAnswer = answers.find(
        (v) => v.type === 'calendarStep',
    ) as CalendarStepT;
    if (calendarStepAnswer) {
        return <BookingConfirmed calendarStepAnswer={calendarStepAnswer} />;
    }

    return (
        <>
            <ThankYouMessage />
            <PoweredByUxSignals />
        </>
    );
};

export default Steps;

const CenterStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

const BottomStyle = css`
    margin-top: auto;
    align-self: flex-end;
`;

const FooterStyle = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    &:last-child {
        padding-top: 10px;
    }
`;
